import React from 'react';
import { PageWrapper } from '../../components/common';
import ListadoPadron from '../../components/padron/ListadoPadron';

const PadronPage: React.FC = () => {
  return (
    <PageWrapper>
      <ListadoPadron />
    </PageWrapper>
  );
};

export default PadronPage;    